import React from "react"

import {
    BadgeCheck,
    ChevronsUpDown,
    LogOut,
} from "lucide-react"

import {
    Avatar,
    AvatarFallback,
    AvatarImage,
} from "@/components/shadcn/avatar"
import {
    DropdownMenu,
    DropdownMenuContent,
    DropdownMenuGroup,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "@/components/shadcn/dropdown-menu"
import {
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/shadcn/sidebar"
import { UserActions } from "@/actions";
import {Link, useNavigate} from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";

export function NavUser() {
    const { isMobile } = useSidebar();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const userProfileData = useSelector((state: any) => state.UserReducer.userProfileData);

    const handleDisconnect = async () => {
        const disconnectUser = await UserActions.logOut(dispatch);

        if (disconnectUser.success && !userProfileData) {
            navigate('/login');
        }
    };

    return (
        <SidebarMenu>
            <SidebarMenuItem className="flex items-center justify-center">
                <DropdownMenu>
                    <DropdownMenuTrigger asChild>
                        <SidebarMenuButton
                            size="lg"
                            className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
                        >
                            <Avatar className="w-8 h-8 bg-orange-200 rounded-full px-auto">
                                <AvatarImage src={userProfileData.avatar} alt={userProfileData.name} />
                                <AvatarFallback className="text-xs text-orange-600 rounded-lg">{userProfileData.userProfileName}</AvatarFallback>
                            </Avatar>
                            <div className="grid flex-1 text-sm leading-tight text-left">
                                <span className="font-semibold truncate">{userProfileData.name}</span>
                                <span className="text-xs truncate">{userProfileData.email}</span>
                            </div>
                            <ChevronsUpDown className="ml-auto size-4" />
                        </SidebarMenuButton>
                    </DropdownMenuTrigger>
                    <DropdownMenuContent
                        className="w-[--radix-dropdown-menu-trigger-width] bg-white min-w-56 rounded-lg"
                        side={isMobile ? "bottom" : "right"}
                        align="end"
                        sideOffset={4}
                    >
                        <DropdownMenuLabel className="p-0 font-normal">
                            <div className="flex items-center gap-2 px-1 py-1.5 text-left text-sm">
                                <Avatar className="w-8 h-8 bg-orange-200 rounded-full">
                                    <AvatarImage src={userProfileData.avatar} alt={userProfileData.name} />
                                    <AvatarFallback className="text-orange-600 rounded-lg">{userProfileData.userProfileName}</AvatarFallback>
                                </Avatar>
                                <div className="grid flex-1 text-sm leading-tight text-left">
                                    <span className="font-semibold truncate">{userProfileData.name}</span>
                                    <span className="text-xs truncate">{userProfileData.email}</span>
                                </div>
                            </div>
                        </DropdownMenuLabel>
                        <DropdownMenuSeparator />
                        <DropdownMenuGroup>
                            <Link to="/account">
                                <DropdownMenuItem className="cursor-pointer">
                                    <BadgeCheck />
                Mon compte
                                </DropdownMenuItem>
                            </Link>
                        </DropdownMenuGroup>
                        <DropdownMenuSeparator />
                        <DropdownMenuItem className="cursor-pointer" onClick={handleDisconnect}>
                            <LogOut />
              Déconnexion
                        </DropdownMenuItem>
                    </DropdownMenuContent>
                </DropdownMenu>
            </SidebarMenuItem>
        </SidebarMenu>
    )
}
